const FundraiserBlogCardShimmer = () => {
  return (
    <div className="flex flex-col gap-2 animate-pulse">
      {/* Image shimmer */}
      <div className="w-full h-[222px] bg-gray-200 rounded-[8px]"></div>
      
      {/* Content shimmer */}
      <div className="flex flex-col gap-2 mt-[24px]">
        {/* Title shimmer */}
        <div className="h-5 bg-gray-200 rounded w-3/4"></div>
        
        {/* Description shimmer */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-full"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
        </div>
      </div>
    </div>
  );
};

export default FundraiserBlogCardShimmer; 